import type { FC } from 'react';

import { Box, Typography } from '@mui/material';
import { StatusBadge } from './status-badge';

interface StatusProps {
  color: string;
  label: string;
  underlined?: boolean;
  spacing?: number;
}

export const Status: FC<StatusProps> = props => {
  const { color, label, underlined, spacing, ...other } = props;

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
      }}
      {...other}>
      <StatusBadge color={color} />
      <Typography
        sx={{
          color,
          ml: spacing ? spacing : 1.75,
          textDecoration: underlined ? 'underline' : 'none',
        }}
        variant="body2">
        {label}
      </Typography>
    </Box>
  );
};
